import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../lib/firebase";

export async function generateUniqueInviteCode() {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

  const generate = () => {
    let code = "";
    for (let i = 0; i < 6; i++) {
      code += chars[Math.floor(Math.random() * chars.length)];
    }
    return code;
  };

  let code;
  let exists = true;

  while (exists) {
    code = generate();

    const q = query(
      collection(db, "houses"),
      where("inviteCode", "==", code)
    );

    const snap = await getDocs(q);
    exists = !snap.empty;
  }

  return code;
}